import { Col, DatePicker, Row, Select, Breadcrumb } from "antd";
import AddExchange from "./AddExchange";
import ExchangeList from "./exchangeList";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { getCurrencyMainDropdown } from "../../api/currency";
import { useMutation, useQuery } from "react-query";
import { Link } from "react-router-dom";
import AddButton from "../UI/AddButton/addbutton";
import { getCurencyRateApi } from "../../api/exchangerate";
import ResetButton from "../UI/ResetButton/resetbutton";
import Title from "../UI/Title/Title";

const Exchange = () => {
  const [selectedCurrency, setSelectedCurrency] = useState<string | undefined>(
    undefined
  );
  const [paginatedCurencyRate, setPaginatedCurencyRate] = useState<any>();
  const [selectedDate, setSelectedDate] = useState<Date | undefined>(undefined);
  const [page, setPage] = useState<number>(1);
  const [tableKey, setTableKey] = useState("");

  const resetFilters = () => {
    getCurencyRates({
      limit: page * 10 + 10,
    }).then((res) => {
      setPaginatedCurencyRate(res.data?.data);
      setSelectedCurrency(undefined);
      setSelectedDate(undefined);
      setTableKey((tableKey) => tableKey + 1);
    });
  };

  const getCurencyRates = async (params: { limit: number }) => {
    // Make your API request here using the updated parameters
    return await CurencyRateMutation(params);
  };

  const { mutateAsync: CurencyRateMutation, isLoading: isCurencyRateLoading } =
    useMutation("CurencyRate", getCurencyRateApi);

  const [formatedCurrency, setFormatedCurrency] = useState<{}[]>();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { t } = useTranslation("common");
  const { isLoading: loadingCurrency } = useQuery(
    "currencies",
    () => getCurrencyMainDropdown(false),
    {
      refetchOnWindowFocus: false,
      onSuccess: (res) => {
        setFormatedCurrency(
          res.data.map((currency: any) => {
            return { value: currency.id, label: currency.name };
          })
        );
      },
    }
  );

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={21}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: (
                  <>
                    <Link to="">{t("system")}</Link>
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {" "}
                    {t("exchange-rate")}{" "}
                  </span>
                ),
              },
            ]}
          />
        </Col>

        <Col offset={1} span={22}>
          <Title title={`${t("exchange-rate")}`} />
        </Col>

        <Col offset={1} span={4}>
          <Select
            key={tableKey}
            style={{ width: "100%", marginTop: "8px" }}
            size="large"
            placeholder={`${t("select-currency")}`}
            loading={loadingCurrency}
            options={formatedCurrency}
            showSearch={true}
            optionFilterProp="label"
            value={selectedCurrency}
            onChange={(value) => {
              if (value !== undefined) {
                setSelectedCurrency(value);
              }
            }}
          />
        </Col>

        <Col span={3}>
          <DatePicker
            key={tableKey}
            placeholder={`${t("select-date")}`}
            style={{ width: "100%", height: "40px", marginTop: "8px" }}
            onChange={(date) => {
              if (date !== null) {
                setSelectedDate(date.toDate());
              } else {
                setSelectedDate(undefined);
              }
            }}
          />
        </Col>

        <Col
          offset={13}
          span={2}
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "8px",
            gap: "20px",
          }}
        >
          <Col>
            <ResetButton
              onClick={() => {
                resetFilters();
                setSelectedCurrency(undefined);
              }}
            />
          </Col>

          <AddButton onClick={() => setIsModalOpen(true)} />
        </Col>

        <Col offset={1} span={22}>
          <ExchangeList
            CurencyRateMutation={CurencyRateMutation}
            selectedDate={selectedDate}
            selectedCurrency={selectedCurrency}
            isCurencyRateLoading={isCurencyRateLoading}
            paginatedCurencyRate={paginatedCurencyRate}
            page={page}
            setPaginatedCurencyRate={setPaginatedCurencyRate}
            setPage={setPage}
          />
        </Col>
      </Row>

      <AddExchange
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        page={page}
        setPaginatedCurencyRate={setPaginatedCurencyRate}
        CurencyRateMutation={CurencyRateMutation}
      />
    </>
  );
};

export default Exchange;
